import { AUTH_TOKEN } from '../constants'

// eslint-disable-next-line no-unused-vars
const AppMiddleware = store => next => action => {
  switch (action.type) {
    case undefined:
      return
    case 'authentication/onLogin':
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(AUTH_TOKEN, action.payload.token)
      }
      break
    case 'authentication/logout':
      if (typeof window !== 'undefined') {
        window.localStorage.setItem(AUTH_TOKEN, null)
        window.localStorage.removeItem(AUTH_TOKEN)
      }
      break
  }
  next(action)
}

export { AppMiddleware }
